<template>
  <b-form-group
    label="Başlangıç Tarihi"
    label-for="sdate"
  >
    <validation-provider
      #default="{ errors }"
      name="Başlangıç Tarihi"
      rules="required"
    >
      <b-form-datepicker
        v-model="itemData.sdate"
        v-bind="{labelNoDateSelected: 'Başlangıç Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
        locale="tr"
        start-weekday="1"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormDatepicker } from 'bootstrap-vue'

export default {
  name: 'SDateNotificationCard',
  components: {
    BFormGroup,
    BFormDatepicker,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['notifications/dataItem']
    },
  },
}
</script>
